import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    modalContent: {
      width: "min(900px, 96vw)",
      maxHeight: "80vh",
    },
    headerText: {
      fontSize: 18,
      fontWeight: 600,
    },
    body: {
      padding: "0 0 16px",
      maxHeight: "60vh",
      overflowY: "auto",
    },
    loader: {
      display: "flex",
      justifyContent: "center",
      padding: 24,
    },
    empty: {
      textAlign: "center",
      color: "#686664",
      padding: 24,
    },
    tableWrap: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
      fontSize: 14,
      color: "#272522",
    },
    th: {
      textAlign: "left",
      fontWeight: 500,
      color: "#686664",
      background: "#F5F5F5",
      padding: "12px 16px",
      whiteSpace: "nowrap",
      borderBottom: "1px solid #EAEAEA",
    },
    td: {
      textAlign: "left",
      padding: "14px 16px",
      borderBottom: "1px solid #EAEAEA",
      verticalAlign: "middle",
    },
    priceCell: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },
    currencyBadge: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 28,
      height: 28,
      padding: "0 6px",
      borderRadius: "50%",
      fontSize: 10,
      fontWeight: 600,
      lineHeight: 1,
    },
    currencyBadgeInr: {
      background: "#D1FAE5",
      color: "#065F46",
    },
    currencyBadgeOther: {
      background: "#E0E7FF",
      color: "#3730A3",
    },
    footer: {
      padding: "12px 16px 0",
      fontSize: 13,
      color: "#686664",
    },
    footerStrong: {
      fontWeight: 600,
      color: "#272522",
    },
  },
  componentName: "PostBookingsModal",
});
